import { Component, OnInit, Input } from '@angular/core';
import { Messages } from 'src/app/core/messages/messages';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-session-confirm-modal',
  templateUrl: './session-confirm-modal.component.html',
  styleUrls: ['./session-confirm-modal.component.scss']
})
export class SessionConfirmModalComponent extends DialogContentBase implements OnInit {

  @Input() headerTitle: string;
  @Input() message: string;
  @Input() buttonTitleFirst: string;
  @Input() buttonTitleSecond: string;

  constructor(public dialog: DialogRef) {
    super(dialog);
  }

  /**
   * Descp: Function called on page init.
   */
  ngOnInit() {
    this.headerTitle = Messages.Dialog_Confirmation_Title;
    this.buttonTitleFirst = Messages.Dialog_Confirmation_Button_Title_First;
    this.buttonTitleSecond = Messages.Dialog_Confirmation_Button_Title_Second;
  }

  btnClickedFirst() {
    this.dialog.close({ data: true });
  }

  btnClickedSecond() {
    this.dialog.close({ data: false });
  }

}
